export const CMS_SNAPSHOT_WARNING_PREFIX = "CCNs not in CMS snapshot:";

const storageKey = (networkId: number) =>
  `unicomply.network.cmsSnapshotWarnings.${networkId}`;

export function isCmsSnapshotWarning(message: string): boolean {
  return message.trim().startsWith(CMS_SNAPSHOT_WARNING_PREFIX);
}

export function extractCmsSnapshotWarnings(
  warnings: string[] | null | undefined,
): string[] {
  if (!warnings?.length) return [];
  return warnings.filter(isCmsSnapshotWarning);
}

export function filterDashboardDataQualityWarnings(
  warnings: string[] | null | undefined,
): string[] {
  if (!warnings?.length) return [];
  return warnings.filter((w) => !isCmsSnapshotWarning(w));
}

/** Facility names + CCNs from a snapshot warning (text after the prefix). */
export function formatCmsSnapshotWarningDetails(message: string): string {
  return message.replace(new RegExp(`^${CMS_SNAPSHOT_WARNING_PREFIX}\\s*`), "").trim();
}

export function loadCmsSnapshotWarnings(networkId: number): string[] {
  try {
    const raw = localStorage.getItem(storageKey(networkId));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => typeof item === "string" && isCmsSnapshotWarning(item));
  } catch {
    return [];
  }
}

export function saveCmsSnapshotWarnings(networkId: number, warnings: string[]): void {
  try {
    localStorage.setItem(storageKey(networkId), JSON.stringify(extractCmsSnapshotWarnings(warnings)));
  } catch {
    // ignore quota / private mode
  }
}
